import gsap from 'gsap';
import { LoopRepeat } from 'three';

function updateAnimations(object, mixer) {
  const actions = {};
  object.animations.forEach((animation) => {
    const action = mixer.clipAction(animation);
    action.loop = LoopRepeat;
    action.enabled = false;
    action.weight = 0;
    actions[animation.name] = action;
    this._actionsAvailable = true;
  });

  return actions;
}

function setAnimation(value) {
  const last = this._animation;
  this._animation = value;

  if (!this._actionsAvailable) return;
  if (!this._actions[value]) {
    console.warn(`Warning: the Kongz animation named '${value}' doesn't exists.`);
    return;
  }

  this._animTl?.kill();
  this._animTl = gsap.timeline();

  this._actions[value].play();
  this._animTl.set(this._actions[value], { enabled: true }, 0);
  this._animTl.to(this._actions[value], { weight: 1, duration: 1 }, 0);

  if (last && last !== value) {
    this._animTl.to(this._actions[last], { weight: 0, duration: 1 }, 0);
    this._animTl.set(this._actions[last], { enabled: false }, 1);
    this._animTl.add(() => {
      this._actions[last].stop();
      this._actions[last].reset();
    }, 1);
  }

  return this._animTl;
}

function playAnimation() {
  this._animationPlaying = true;
}

function pauseAnimation() {
  this._animationPlaying = false;
}

export { updateAnimations, setAnimation, playAnimation, pauseAnimation };
